import { Type, type Static } from "@sinclair/typebox";
import { UuidSchema } from "./identifiers.ts";

export const REGISTERED_AGENT_LIMITS = Object.freeze({
  maxItems: 64,
  maxAgentKeyChars: 64,
  maxDisplayNameChars: 128,
  maxDescriptionChars: 2_048,
  maxMatrixUserIdChars: 512
});

export const AGENT_KEY_PATTERN = "^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$";
export const MATRIX_USER_ID_PATTERN = "^@[^:\\s]+:[^\\s:]+$";

export const AgentKeySchema = Type.String({
  minLength: 1,
  maxLength: REGISTERED_AGENT_LIMITS.maxAgentKeyChars,
  pattern: AGENT_KEY_PATTERN
});

export const MatrixUserIdSchema = Type.String({
  minLength: 4,
  maxLength: REGISTERED_AGENT_LIMITS.maxMatrixUserIdChars,
  pattern: MATRIX_USER_ID_PATTERN
});

const AgentDisplayNameSchema = Type.String({
  minLength: 1,
  maxLength: REGISTERED_AGENT_LIMITS.maxDisplayNameChars
});
const AgentDescriptionSchema = Type.String({
  minLength: 1,
  maxLength: REGISTERED_AGENT_LIMITS.maxDescriptionChars
});
const TimestampSchema = Type.String({ format: "date-time" });

export const RegisteredAgentSchema = Type.Object(
  {
    agentId: UuidSchema,
    agentKey: AgentKeySchema,
    displayName: AgentDisplayNameSchema,
    description: AgentDescriptionSchema,
    matrixBotMxid: MatrixUserIdSchema,
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema
  },
  { additionalProperties: false }
);

export const AgentDirectoryItemSchema = Type.Object(
  {
    agentId: UuidSchema,
    agentKey: AgentKeySchema,
    displayName: AgentDisplayNameSchema,
    description: AgentDescriptionSchema,
    matrixBotMxid: MatrixUserIdSchema
  },
  { additionalProperties: false }
);

export const AgentDirectoryResponseSchema = Type.Object(
  {
    items: Type.Array(AgentDirectoryItemSchema, {
      maxItems: REGISTERED_AGENT_LIMITS.maxItems
    })
  },
  { additionalProperties: false }
);

export const RegisteredAgentIdentityResponseSchema = Type.Object(
  {
    agentId: UuidSchema,
    agentKey: AgentKeySchema,
    matrixBotMxid: MatrixUserIdSchema
  },
  { additionalProperties: false }
);

export type RegisteredAgentV1 = Static<typeof RegisteredAgentSchema>;
export type AgentDirectoryItemV1 = Static<typeof AgentDirectoryItemSchema>;
export type AgentDirectoryResponseV1 = Static<typeof AgentDirectoryResponseSchema>;
export type RegisteredAgentIdentityResponseV1 = Static<
  typeof RegisteredAgentIdentityResponseSchema
>;
